import { render, staticRenderFns } from "./CollectionTypeForm.vue?vue&type=template&id=71ba9951&"
import script from "./CollectionTypeForm.vue?vue&type=script&lang=ts&"
export * from "./CollectionTypeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports